import { useNavigate } from "react-router-dom";
import { useTheme } from "../../components/hooks/useTheme";
import { useEffect, useState } from "react";
import baseURL from "../../configs/api";
import axios from "axios";
import { Tabs } from "../../components/common/Tabs";
import { DailyNotesList } from "./DailyNotesList";
import colorConfigs from "../../configs/colorConfigs";
import Cookies from "js-cookie";
import useTenant from "../../components/hooks/useTenant";

type TabType = {
  id: number,
  label: string
}

const filterItems = [
  {
    id: 0,
    label: "Notes",
  },
  {
    id: 1,
    label: "Created By",
  },
]

export const DailyNotes = () => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { handleTenantError }: any = useTenant();
  const { themeStyles } = useTheme();
  const navigate = useNavigate();
  const [tabs, setTabs] = useState<TabType[]>([{
    id: 0,
    label: "All"
  }]);
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const [activeTabLable, setActiveTabLable] = useState<string>("All");
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [searchValue, setSearchValue] = useState<string>("");
  const [notesFilterValue, setNotesFilterValue] = useState(0);
  const [selectedFilter, setSelectedFilter] = useState<string>(filterItems[0].label);

  const hanbleTabChange = (index: number, tab: any) => {
    setActiveIndex(tab?.id || index);
    setCurrentIndex(index);
    setActiveTabLable(tab?.label);
    setSearchValue("");
    setSelectedFilter(filterItems[0].label);
    setNotesFilterValue(0);
    setPaginationModel({
      page: 0,
      pageSize: 10,
    })
  }

  useEffect(() => {
    axios
      .get(`${baseURL}location`, {
        headers: {
          'X-Tenant-ID': tenantId,
           "Content-Type": "application/json" 
        },
      })
      .then((response) => {
        response.data.forEach((item: any) => {
          setTabs((tabs) => [
            ...tabs,
            {
              id: item.id,
              label: item.locationName,
            },
          ]);
        });
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (
    <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
      <div className={`w-full ${themeStyles.main.tailwindMainBg} border ${themeStyles.main.borderColor} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
        <div className="flex items-center justify-end">
          <div className="flex items-center gap-2.5">
            <button className={`px-[8px] py-[6px] ${colorConfigs.btn.main.tailwind} rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
              onClick={() => navigate("/daily-notes/add-daily-notes")}
            >
              <span className="material-symbols-outlined text-[25px] font-light">
                add
              </span>
              <span className="text-xs font-medium">Daily Notes</span>
            </button>

          </div>
        </div>
        <div className="w-full mt-2">
          <Tabs tabs={tabs} onChange={(index, tab) => hanbleTabChange(index, tab)} activeIndex={currentIndex} />
        </div>

        <div>
          <DailyNotesList
            activeIndex={activeIndex}
            activeTabLable={activeTabLable}
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            notesFilterValue={notesFilterValue}
            setNotesFilterValue={setNotesFilterValue}
            selectedFilter={selectedFilter}
            setSelectedFilter={setSelectedFilter}
            filterItems={filterItems}
          />
        </div>
      </div>
    </div>
  );
};


